import React from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import { StripeProvider } from './contexts/StripeProvider';
import { Routes } from './Routes';

function App() {
  return (
    <ErrorBoundary>
      <StripeProvider>
        <Routes />
      </StripeProvider>
    </ErrorBoundary>
  );
}

export default App;